import React, { useState } from "react";
import { Modal, ModalButtonID, Checkbox } from '../../../ui/components';
import Path from '../../../components/Path/Path';
import styles from './Create.less';
export default function Create({ localPath, remotePath, filter, onClose }) {
    const [recursive, setRecursive] = useState(true);
    const [del, setDel] = useState(true);
    const buttons = [
        {
            id: ModalButtonID.Cancel,
            label: 'Cancel'
        },
        {
            id: ModalButtonID.Ok,
            label: 'Start'
        }
    ];
    return React.createElement(Modal, { buttons: buttons, onClose: id => onClose(id == ModalButtonID.Ok ? { recursive, del } : undefined), options: { x: true } },
        React.createElement("div", { className: 'modal-content' },
            React.createElement("header", null, "Set up synchronization"),
            React.createElement("p", null,
                "Watch for changes in the local folder:",
                React.createElement("em", null,
                    React.createElement(Path, { path: localPath, type: 'local' }))),
            React.createElement("p", null,
                "and synchronize them to the remote folder:",
                React.createElement("em", null,
                    React.createElement(Path, { path: remotePath, type: 'remote' }))),
            React.createElement("p", null,
                React.createElement(Checkbox, { onChange: setRecursive, value: recursive },
                    React.createElement("span", { className: styles.flag },
                        React.createElement("i", { className: "icon" }, "folder_copy"),
                        React.createElement("span", null,
                            "Include subfolders",
                            React.createElement("small", null, "Watch for changes in all folders within the chosen root folder"))))),
            React.createElement("p", null,
                React.createElement(Checkbox, { onChange: setDel, value: del },
                    React.createElement("span", { className: styles.flag },
                        React.createElement("i", { className: "icon" }, "delete"),
                        React.createElement("span", null,
                            "Delete remote files",
                            React.createElement("small", null, "Delete remote files when the corresponding local files are deleted"))))),
            filter &&
                React.createElement("div", { className: "info" }, "Only files matching the current filter will be synced.")));
}
